<template>
    <v-container class="experience-item-text">
        <v-row dense class="mb-10">
            <v-col cols="12">
                <h1 class="text-uppercase page-header text-center">{{ experience.company }}</h1>
            </v-col>
        </v-row>
        <v-row>
            <v-col>
                <div class="mb-1">
                    <h3 class="page-header-secondary text-center">{{ experience.title }}</h3>
                </div>
                <div class="d-flex justify-center mb-8">
                    <span class="mr-2">
                        <font-awesome-icon :icon="['fas', 'map-marker-alt']" size="xs"/>
                    </span>
                    <span>
                        <h3 class="page-sub-header text-center">{{ experience.location }}</h3>
                    </span>
                </div>
                <div>
                    <h3 class="page-sub-header text-center">{{ experience.date }}</h3>
                </div>
            </v-col>
        </v-row>
        <v-row class="justify-center">
            <v-col cols="12" lg="8" xl="6">
                <p>{{ experience.description }}</p>
            </v-col>
        </v-row>
        <v-row class="justify-center" v-for="extra in experience.extras" :key="extra.title">
            <v-col cols="12" lg="8" xl="6">
                <ExperienceExtraItem :extraItem="extra" />
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    import ExperienceExtraItem from './ExperienceExtraItem';
    import experiences from '@/data/experiences';

    export default {
        name: 'ExperienceItem',
        components: {
            ExperienceExtraItem,
        },
        props: {
            id: String,
        },
        watch: {
            id(newVal, oldVal) {
                if (newVal != oldVal)
                    window.scrollTo(0,0);
            }
        },
        computed: {
            experience() {
                return experiences.filter(p => p.id == this.id)[0];
            }
        },
    }
</script>

<style lang="scss" scoped>
@import 'src/assets/scss/global.scss';

.experience-item-text {
    text-align: left;

    .experience-company {
        color: $companyName;
        font-weight: bold;
    }
    .experience-title {
        color: $positionTitle;
    }
    .experience-date {
        color: $positionDates;
    }
    .experience-description {
        padding-top: 12px;
        text-align: justify;
    }
}

.extra-button {
    padding-right: 10px;
}

</style>

